import type { ThemePreset } from "../types";

export const academyDark: ThemePreset = {
  id: "academy-dark",
  name: "Academy Dark",
  nameKey: "admin.settings.appearance.themes.academy-dark.name",
  description: "Dunkles Blaugrau mit Indigo/Violett-Akzent",
  descriptionKey: "admin.settings.appearance.themes.academy-dark.description",
  light: {
    background: "oklch(0.98 0.005 287)",
    foreground: "oklch(0.15 0.02 287)",
    card: "oklch(1 0 0)",
    "card-foreground": "oklch(0.15 0.02 287)",
    popover: "oklch(1 0 0)",
    "popover-foreground": "oklch(0.15 0.02 287)",
    primary: "oklch(0.585 0.222 287)",
    "primary-foreground": "oklch(0.985 0 0)",
    secondary: "oklch(0.94 0.01 287)",
    "secondary-foreground": "oklch(0.25 0.02 287)",
    muted: "oklch(0.94 0.01 287)",
    "muted-foreground": "oklch(0.50 0.02 287)",
    accent: "oklch(0.95 0.025 209)",
    "accent-foreground": "oklch(0.25 0.02 287)",
    destructive: "oklch(0.65 0.24 27)",
    "destructive-foreground": "oklch(0.985 0 0)",
    border: "oklch(0.90 0.01 287)",
    input: "oklch(0.90 0.01 287)",
    ring: "oklch(0.585 0.222 287)",
    "sidebar-background": "oklch(0.25 0.025 285)",
    "sidebar-foreground": "oklch(0.85 0.01 287)",
    "sidebar-primary": "oklch(0.70 0.21 287)",
    "sidebar-primary-foreground": "oklch(0.15 0.02 287)",
    "sidebar-accent": "oklch(0.30 0.04 287)",
    "sidebar-accent-foreground": "oklch(0.92 0.01 287)",
    "sidebar-border": "oklch(0.32 0.02 285)",
    "sidebar-ring": "oklch(0.70 0.21 287)",
  },
  dark: {
    background: "oklch(0.20 0.02 285)",
    foreground: "oklch(0.92 0.01 287)",
    card: "oklch(0.23 0.025 285)",
    "card-foreground": "oklch(0.92 0.01 287)",
    popover: "oklch(0.23 0.025 285)",
    "popover-foreground": "oklch(0.92 0.01 287)",
    primary: "oklch(0.70 0.21 287)",
    "primary-foreground": "oklch(0.15 0.02 287)",
    secondary: "oklch(0.25 0.025 285)",
    "secondary-foreground": "oklch(0.90 0.01 287)",
    muted: "oklch(0.25 0.02 285)",
    "muted-foreground": "oklch(0.62 0.02 287)",
    accent: "oklch(0.28 0.04 209)",
    "accent-foreground": "oklch(0.92 0.01 287)",
    destructive: "oklch(0.65 0.22 27)",
    "destructive-foreground": "oklch(0.98 0 0)",
    border: "oklch(0.30 0.02 285)",
    input: "oklch(0.30 0.02 285)",
    ring: "oklch(0.70 0.21 287)",
    "sidebar-background": "oklch(0.17 0.02 285)",
    "sidebar-foreground": "oklch(0.82 0.015 287)",
    "sidebar-primary": "oklch(0.70 0.21 287)",
    "sidebar-primary-foreground": "oklch(0.15 0.02 287)",
    "sidebar-accent": "oklch(0.26 0.04 287)",
    "sidebar-accent-foreground": "oklch(0.92 0.01 287)",
    "sidebar-border": "oklch(0.28 0.02 285)",
    "sidebar-ring": "oklch(0.70 0.21 287)",
  },
};
